import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, withModifiers as _withModifiers, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, toDisplayString as _toDisplayString } from "vue";
const _hoisted_1 = { class: "form__control" };
const _hoisted_2 = {
    key: 0,
    class: "file"
};
const _hoisted_3 = ["id", "disabled", "accept", "required", "multiple"];
const _hoisted_4 = {
    key: 3,
    class: "error"
};
import { ref, watch, computed } from 'vue';
import log from "../../services/Logger";
import palomaFiles from "../../services/PalomaFiles";
import FileLink from "../FileLink.vue";
import Icon from "../Icon.vue";
import Spinner from "../Spinner.vue";
import ProgressBar from "../ProgressBar.vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'FieldControlFile',
    props: {
        form: {},
        validation: {},
        field: {},
        fieldId: {},
        data: {}
    },
    emits: [
        'change',
        'focus',
        'blur'
    ],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const root = ref(null);
        const fieldOptions = ref(props.field.options || {});
        const model = ref(undefined);
        const acceptedFiles = ref(null);
        const loading = ref(false);
        const progress = ref(0);
        const error = ref(null);
        const showFileLink = computed(() => {
            return props.data && (typeof props.data === 'string');
        });
        fieldOptions.value = props.field.options || {};
        initModel();
        if (fieldOptions.value.acceptedFiles) {
            acceptedFiles.value = fieldOptions.value.acceptedFiles.reduce((v1, v2) => v1 + ',' + v2);
        }
        watch(() => props.data, initModel);
        function initModel() {
            model.value = props.data;
        }
        function clear() {
            emit('change', null);
        }
        function onChange() {
            const files = root.value?.files;
            log('FieldControlFiles@change', props.field.name, files);
            const bucket = fieldOptions.value.storageLocation;
            if (!bucket) {
                // behave like a normal file input
                emit('change', files);
                return;
            }
            // upload to Paloma files bucket
            if (!files || files.length === 0) {
                emit('change', null);
                return;
            }
            if (files.length > 1) {
                throw 'Multiple files are currently not supported';
            }
            loading.value = true;
            palomaFiles
                .upload(bucket, files[0], progressEvent => {
                progress.value = progressEvent.loaded / progressEvent.total;
                log(`Upload progress: ${progress.value * 100}%`, progressEvent);
            })
                .then(file => {
                emit('change', file.internalUri);
            })
                .catch(e => {
                error.value = e.response.data.message;
            })
                .finally(() => {
                loading.value = false;
                progress.value = 0;
            });
            // TODO delete previously uploaded but unsaved?
            // TODO prevent form submit during upload
        }
        function onFocus() {
            emit('focus');
        }
        function onBlur() {
            emit('blur');
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                (showFileLink.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                        _createVNode(FileLink, { uri: __props.data }, null, 8, ["uri"]),
                        _cache[0] || (_cache[0] = _createTextVNode()),
                        _createElementVNode("div", {
                            onClick: _withModifiers(clear, ["prevent"]),
                            class: "file__clear"
                        }, [
                            _createVNode(Icon, { name: "times-circle" })
                        ])
                    ]))
                    : _createCommentVNode("", true),
                _cache[1] || (_cache[1] = _createTextVNode()),
                _createVNode(Spinner, { loading: loading.value }, null, 8, ["loading"]),
                _cache[2] || (_cache[2] = _createTextVNode()),
                (loading.value)
                    ? (_openBlock(), _createBlock(ProgressBar, {
                        key: 1,
                        progress: progress.value
                    }, null, 8, ["progress"]))
                    : _createCommentVNode("", true),
                _cache[3] || (_cache[3] = _createTextVNode()),
                (!loading.value)
                    ? (_openBlock(), _createElementBlock("input", {
                        key: 2,
                        ref_key: "root",
                        ref: root,
                        onChange: onChange,
                        onFocus: onFocus,
                        onBlur: onBlur,
                        type: "file",
                        id: __props.fieldId,
                        disabled: fieldOptions.value.disabled ?? undefined,
                        accept: acceptedFiles.value ?? undefined,
                        required: fieldOptions.value.required ?? undefined,
                        multiple: fieldOptions.value.multiple ?? undefined
                    }, null, 40, _hoisted_3))
                    : _createCommentVNode("", true),
                _cache[4] || (_cache[4] = _createTextVNode()),
                (error.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(error.value), 1))
                    : _createCommentVNode("", true)
            ]));
        };
    }
});
